import apiClient, { strapiApiUrl } from "@/api/api";

async function getAppConfig(identifier: string) {
  return apiClient.get(`${strapiApiUrl}/organisations/app-config?appIdentifier=${identifier}`);
}

export default {
  getAppConfig
}
